import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { Checkbox, FormControl, InputLabel, Select, MenuItem, Grid, FormControlLabel, Dialog, DialogTitle, DialogContent, IconButton, Switch, DialogActions } from '@mui/material';
import { Container, Button, Paper, Typography, Table, TableHead, TableBody, TableRow, TableCell, TableContainer, TextField, Stack } from '@mui/material';
import { BASE_URL } from "../../App";
import CustomTextField from "../Reusable/Numerictext";
import { SelectSearch } from '../Reusable/SelectBox';
import { Row, Col, Card } from 'antd';
import dayjs from 'dayjs';
import { Modal, Box } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Autocomplete from '@mui/material/Autocomplete';
//import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import ReceiptLongTwoToneIcon from '@mui/icons-material/ReceiptLongTwoTone';
import UndoTwoToneIcon from '@mui/icons-material/UndoTwoTone';
// import DatePicker from 'react-datepicker';
import { DatePicker } from '@mui/x-date-pickers';
import "react-datepicker/dist/react-datepicker.css";
import { width } from '@mui/system';
// import './approval.css';
import { Backdrop, CircularProgress } from '@mui/material';
import Notfoundimage from '../image/6167023.png';

const Service_Claim_BM_Approval =  ({ doc_no, serial_no })=> {
  const [serviceClaims, setServiceClaims] = useState([]);
  const [open1, setOpen1] = React.useState(false);
  // const [status, setstatus] = useState([]);


  const [callheader, setcallheader] = useState([]);
  const [dealerdesc, setdealerdesc] = useState([]);
  const [itemdesc, setitemdes] = useState([]);

  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedstatus, setSelectedstatus] = useState("Close");


  const [selectedRowData, setSelectedRowData] = useState(null);


  const [openCard, setOpenCard] = useState(false);
  const [showTable, setShowTable] = useState(true);
  const [header, setHeader] = useState([]);
  const [callHeader, setCallHeader] = useState([]);
  const [dealerDesc, setDealerDesc] = useState([]);

  const [loading, setloading] = React.useState(false);
  const login_id = localStorage.getItem("LOGIN_ID");
  const [callpre, setCallpre] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');

  const [selectedclaim, setSelectedclaim] = useState('');
  const [isGSTApplicable, setIsGSTApplicable] = useState(false);
  const [billNo, setBillNo] = useState('');
  const [billDate, setBillDate] = useState('');
  const [costCentre, setCostCentre] = useState('');
  const [dealerCode, setDealerCode] = useState('');
  const [ascName, setAscName] = useState('');
  const [docNo, setDocNo] = useState('');
  const [serialNo, setSerialNo] = useState('');
  const [itemCode, setItemCode] = useState('');
  const [itemDesc, setItemDesc] = useState('');
  const [serviceCallItemNo, setServiceCallItemNo] = useState('');
  const [serviceType, setServiceType] = useState('');
  const [receivedFrom, setReceivedFrom] = useState('');
  const [complaintReason, setComplaintReason] = useState('');
  const [mobile, setMobile] = useState('');
  const [address, setAddress] = useState('');
  const [openn, setOpenn] = useState(false);
  const [selectedImagee, setSelectedImagee] = useState('');
  const [costcenter, setcostcenter] = useState([]);
  const [sparescost, setsparescost] = useState([]);
  const [labourcost, setlabourcost] = useState([]);
  const [productregistration, setproductregistration] = useState([]);
  const [imageUrls, setImageUrls] = useState([]); // Initialize state for image URLs
  const billNoInputRef = useRef(null);
  const billDateInputRef = useRef(null);
  const status1InputRef = useRef(null);
  const costcenter1InputRef = useRef(null);


  const [images, setImages] = useState({
    image1: '',
    image2: '',
    image3: '',
    image4: ''
  });
  const [openi, setOpenni] = useState(false);
  const [selectedImagei, setSelectedImagei] = useState('');
  const [selectedBase64, setSelectedBase64] = useState('');
  const notFoundImage = Notfoundimage;
  const [schead, setShead] = useState([]);
  const [error, setError] = useState('');
  const [error1, setError1] = useState('');
  const [error2, setError2] = useState('');
  const [error3, setError3] = useState('');
  // Function to open the dialog with the selected image
  const handleClickOpen = (imageUrl) => {
    setSelectedImage(imageUrl); // Set the selected image
    setOpen(true); // Open the dialog
  };

  // Function to close the dialog
  const handleClosee = () => {
    setOpen(false); // Close the dialog
    setSelectedImage(''); // Clear the selected image
  };
  const handleclaimchange = (event, newValue) => {
    setloading(true);
    setSelectedclaim(newValue);
    console.log('Selected Claim:', selectedclaim.value);
    fetchData(newValue);
  };

  const openModal = (image,) => {
    setSelectedImagei(image); // For displaying the image
    // For displaying the base64 string
    setOpen(true);
  };

  // Handle closing the modal
  const handleClosemodal = () => {
    setOpen(false);
  };


  // Reusable CheckboxField Component


  // Main Form Component

  const [formData, setFormData] = useState({
    isGSTApplicable: false,
    billNo: '',
    billDate: '',
    costcentre: '',
    dealerCode: '',
    ascName: '',
    docNo: '',
    serialNo: '',
    itemCode: '',
    itemDesc: '',
    serviceCallItemNo: '',
    serviceType: '',
    receivedFrom: '',
    complaintReason: '',
    mobile: '',
    address: '',
    status: '',
    deliverydate: '',
    claimfrom: '',
    branch: '',
    claimamount: '',
    approvedamount: '',
    approvedby: '',
    sparesclaim: '',
    sparesclaimapp: '',
    labourclaim: '',
    labourclaimapp: '',
    labourCGST: '',
    labourCGSTApproved: '',
    labourSGST: '',
    labourSGSTApproved: '',
    labourIGSTApproved: '',
    labourIGST: '',
    status1: '',


  });
  const [ip, setIp] = useState(null);

  useEffect(() => {
    const fetchIP = async () => {
      try {
        const response = await axios.get('https://api.ipify.org?format=json');
        setIp(response.data.ip);
      } catch (error) {
        console.error('Error fetching IP:', error);
      }
    };

    fetchIP();
  }, []);

  const handleSave = async () => {
    try {
      setloading(true);

      if (!formData.status1) {
        setError1('Please Select the Approval Status!');
        setloading(false); // Reset loading state if needed
        if (status1InputRef.current) {
          status1InputRef.current.scrollIntoView({
            behavior: 'smooth', // Smooth scroll effect
            block: 'center', // Center the input field in the viewport
            inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
          });
        }
        return; 
      }
      setError1('');

      const requestData = {
        doc_no: formData.docNo,
        login_id: login_id,
        approval_status: formData.status1,
        bill_no: formData.billNo,
        bill_date: formData.billDate,
        serial_no: formData.serialNo,
        claim: formData.claimamount,
        claim_app: formData.approvedamount,
        labclaim: formData.labourclaim,
        labclaim_app: formData.labourclaimapp,
        labcgst: formData.labourCGST,
        labcgst_app: formData.labourCGSTApproved,
        labsgst: formData.labourSGST,
        labsgst_app: formData.labourSGSTApproved,
        labigst: formData.labourIGST,
        labigst_app: formData.labourIGSTApproved,
        spareclaim: formData.sparesclaim,
        spareclaim_app: formData.sparesclaimapp,
        tsparetotal: formattedTotalAmount,
        tsparecgsttotal: formattedTotalCGST,
        tsparesgsttotal: formattedTotalSGST,
        tsparesigsttotal: formattedTotalIGST,
        tlabourtotal: formattedTotalAmountt, // It seems like this should be a total, check your logic here
        tlabourcgsttotal: formattedTotalCGSTT,
        tlaboursgsttotal: formattedTotalSGSTT,
        tlabourigsttotal: formattedTotalIGSTT,
        comments: formData.reason,
        sparecost: sparescost,
        labourcost: labourcost,
        cost_center: formData.costcentre,
        ip: ip
      };

      const response = await axios.post(BASE_URL + '/scbmapproval', requestData);

      // Check if the response was successful
      if (response.data.status_code === 200) {
        setloading(false);
        Swal.fire({
          icon: 'success',
          text: response.data.message,
          confirmButtonText: 'Okay',
        });
        setFormData({
          isGSTApplicable: false,
          billNo: '',
          billDate: '',
          costcentre: '',
          dealerCode: '',
          ascName: '',
          docNo: '',
          serialNo: '',
          itemCode: '',
          itemDesc: '',
          serviceCallItemNo: '',
          serviceType: '',
          receivedFrom: '',
          complaintReason: '',
          mobile: '',
          address: '',
          status: '',
          deliverydate: '',
          claimfrom: '',
          branch: '',
          claimamount: '',
          approvedamount: '',
          approvedby: '',
          sparesclaim: '',
          sparesclaimapp: '',
          labourclaim: '',
          labourclaimapp: '',
          labourCGST: '',
          labourCGSTApproved: '',
          labourSGST: '',
          labourSGSTApproved: '',
          labourIGSTApproved: '',
          labourIGST: '',
          status1: '',
        });
        setError2('');
        setIsGSTApplicable(false);
        setOpenCard(false);
        setShowTable(true);
        handleCloseCard(); 

      } else if (response.data.status_code === '400') {
        setloading(false);
        Swal.fire({
          icon: 'info',
          text: response.data.message,
          confirmButtonText: 'Okay',
        });
      } else if (response.data.status_code === '500') {

        setError3('Please Select the Cost Center!'); // Set error message
        setloading(false); // Reset loading state if needed
        if (costcenter1InputRef.current) {
          costcenter1InputRef.current.scrollIntoView({
            behavior: 'smooth', // Smooth scroll effect
            block: 'center', // Center the input field in the viewport
            inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
          });
        }
        return;


      }
      else if (response.data.status_code === '600') {
        //alert('1');
        setError2(response.data.message); // Set error message
        //   console.log(error2);
        setloading(false); // Reset loading state if needed
        if (billDateInputRef.current) {
          billDateInputRef.current.scrollIntoView({
            behavior: 'smooth', // Smooth scroll effect
            block: 'center', // Center the input field in the viewport
            inline: 'nearest', // Ensure the element stays within the viewport's horizontal boundaries
          });
        }
        return;


      }
      else {
        setloading(false);
        // Swal.fire({
        //   icon: 'info',
        //   text: response.data.message,
        //   confirmButtonText: 'Okay',
        // });
      }

    } catch (error) {
      setloading(false);
      // Log error to the console for debugging
      console.error('Error occurred:', error);

      // Show an error message using Swal
      Swal.fire({
        icon: 'info',
        // title: 'An error occurred',
        text: 'Something went wrong while saving the data. Please try again.',
        confirmButtonText: 'Okay',
      });
    }
  };


  const statusoptions = [
    { Label: "APPROVED", value: "APPROVED" },
    { Label: "REJECTED", value: "REJECTED" },
    { Label: "WRONG ENTRY", value: "WRONG ENTRY" },
  ];



  const handleSwitchChange = async (event) => {
    // Get the new state of the switch
    setloading(true);
    const newIsGSTApplicable = event.target.checked;
    setIsGSTApplicable(newIsGSTApplicable);

    try {
      if (newIsGSTApplicable) {
        // Call API when the switch is checked (GST applicable)
        axios.post(BASE_URL + '/calcscgstdetails', {
          doc_no: formData.docNo,
          login_id: login_id,
        })
          .then(response => {

            const responseData = response.data;
            const sparetotals = responseData.spare_totals || '';
            const labourtotals = responseData.labour_totals || '';

            setsparescost(responseData.sparescharge || {});
            setlabourcost(responseData.labourcharge || {});
            setloading(false);

            setFormData((prevState) => ({
              ...prevState,
              claimamount: (responseData.total_claim_amount == null || responseData.total_claim_amount === "" || responseData.total_claim_amount == 0 || responseData.total_claim_amount == 0.00) ? '0.00' : parseFloat(responseData.total_claim_amount).toFixed(2),
              approvedamount: (responseData.total_claim_amount == null || responseData.total_claim_amount === "" || responseData.total_claim_amount == 0 || responseData.total_claim_amount == 0.00) ? '0.00' : parseFloat(responseData.total_claim_amount).toFixed(2),
              labourCGST: (labourtotals.total_labour_CGST == null || labourtotals.total_labour_CGST === "" || labourtotals.total_labour_CGST == 0.00 || labourtotals.total_labour_CGST == 0) ? '0.00' : parseFloat(labourtotals.total_labour_CGST).toFixed(2),
              sparesclaim: (sparetotals.total_spare_amount == null || sparetotals.total_spare_amount === "" || sparetotals.total_spare_amount == 0.00 || sparetotals.total_spare_amount == 0) ? '0.00' : parseFloat(sparetotals.total_spare_amount).toFixed(2),
              sparesclaimapp: (sparetotals.total_spare_amount == null || sparetotals.total_spare_amount === "" || sparetotals.total_spare_amount == 0.00 || sparetotals.total_spare_amount == 0) ? '0.00' : parseFloat(sparetotals.total_spare_amount).toFixed(2),
              labourclaim: (labourtotals.labour_ded == null || labourtotals.labour_ded === "" || labourtotals.labour_ded == 0.00 || labourtotals.labour_ded == 0) ? '0.00' : parseFloat(labourtotals.labour_ded).toFixed(2),
              labourclaimapp: (labourtotals.labour_ded == null || labourtotals.labour_ded === "" || labourtotals.labour_ded == 0.00 || labourtotals.labour_ded == 0) ? '0.00' : parseFloat(labourtotals.labour_ded).toFixed(2),
              labourCGSTApproved: (labourtotals.total_labour_CGST == null || labourtotals.total_labour_CGST === "" || labourtotals.total_labour_CGST == 0.00 || labourtotals.total_labour_CGST == 0) ? '0.00' : parseFloat(labourtotals.total_labour_CGST).toFixed(2),
              labourSGST: (labourtotals.total_labour_SGST == null || labourtotals.total_labour_SGST === "" || labourtotals.total_labour_SGST == 0.00 || labourtotals.total_labour_SGST == 0) ? '0.00' : parseFloat(labourtotals.total_labour_SGST).toFixed(2),
              labourSGSTApproved: (labourtotals.total_labour_SGST == null || labourtotals.total_labour_SGST === "" || labourtotals.total_labour_SGST == 0.00 || labourtotals.total_labour_SGST == 0) ? '0.00' : parseFloat(labourtotals.total_labour_SGST).toFixed(2),
              labourIGST: (labourtotals.total_labour_IGST == null || labourtotals.total_labour_IGST === "" || labourtotals.total_labour_IGST == 0.00 || labourtotals.total_labour_IGST == 0) ? '0.00' : parseFloat(labourtotals.total_labour_IGST).toFixed(2),
              labourIGSTApproved: (labourtotals.total_labour_IGST == null || labourtotals.total_labour_IGST === "" || labourtotals.total_labour_IGST == 0.00 || labourtotals.total_labour_IGST == 0) ? '0.00' : parseFloat(labourtotals.total_labour_IGST).toFixed(2)
            }));
          })
          .catch(error => {
            console.error('Error fetching claim details:', error);
            setloading(false);
          });

      } else {
        axios.post(BASE_URL + '/getscclaimdetails', {
          doc_no: formData.docNo,
          login_id: login_id,
          type:'BM',
        })
          .then(response => {
            setloading(false);
            const responseData = response.data;
            const headerDetails = responseData.scheader[0] || {};
            const headerReportDetails = responseData.screportheader[0] || {};
            const headeritemdetails = responseData.item[0] || {};
            setcostcenter(responseData.costcenter || []);
            setsparescost(responseData.sparescharge || {});
            setlabourcost(responseData.labourcharge || {});
            setproductregistration(responseData.productregistration || {});


            setImages((prevState) => ({
              ...prevState,
              image1: responseData.image1 || '',
              image2: responseData.image2 || '',
              image3: responseData.image3 || '',
              image4: responseData.image4 || '',
            }));


            setFormData((prevState) => ({
              ...prevState,
              costCentre: headerDetails.COSTCENTRE_CODE || '',
              dealerCode: headerDetails.DEALER_CODE || '',
              ascName: headerDetails.ASC_NAME || '',
              docNo: headerDetails.DOC_NO || '',
              serialNo: headerDetails.SERIAL_NO || '',
              itemCode: headerDetails.MAT_CODE || '',
              itemDesc: headeritemdetails.itemdescription || '',
              serviceCallItemNo: headerDetails.SERVICECALL_NO || '',
              serviceType: headerReportDetails.SERVICE_TYPE || '',
              receivedFrom: headerReportDetails.CUSTOMER_NAME || '',
              complaintReason: headerReportDetails.COMPLAINT || '',
              mobile: headerReportDetails.CUSTOMER_PHONE_NUMBER || '',
              address: headerReportDetails.CUSTOMER_ADDRESS || '',
              branch: headerDetails.BRANCH_CODE || '',
              claimamount: (headerDetails.CLAIM_AMOUNT == null || headerDetails.CLAIM_AMOUNT === "" || headerDetails.CLAIM_AMOUNT == 0 || headerDetails.CLAIM_AMOUNT == 0.00) ? '0.00' : parseFloat(headerDetails.CLAIM_AMOUNT).toFixed(2),
              approvedamount: (headerDetails.APPROVED_AMOUNT == null || headerDetails.APPROVED_AMOUNT === "" || headerDetails.APPROVED_AMOUNT == 0 || headerDetails.APPROVED_AMOUNT == 0.00) ? '0.00' : parseFloat(headerDetails.APPROVED_AMOUNT).toFixed(2),
              approvedby: responseData.loginid || '',
              labourCGST: (headerDetails.LABOUR_CGST_TAX == null || headerDetails.LABOUR_CGST_TAX === "" || headerDetails.LABOUR_CGST_TAX == 0.00 || headerDetails.LABOUR_CGST_TAX == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_CGST_TAX).toFixed(2),
              sparesclaim: (headerDetails.SPARESCLAIM == null || headerDetails.SPARESCLAIM === "" || headerDetails.SPARESCLAIM == 0.00 || headerDetails.SPARESCLAIM == 0) ? '0.00' : parseFloat(headerDetails.SPARESCLAIM).toFixed(2),
              sparesclaimapp: (headerDetails.SPARESCLAIMAPPROVED == null || headerDetails.SPARESCLAIMAPPROVED === "" || headerDetails.SPARESCLAIMAPPROVED == 0.00 || headerDetails.SPARESCLAIMAPPROVED == 0) ? '0.00' : parseFloat(headerDetails.SPARESCLAIMAPPROVED).toFixed(2),
              labourclaim: (headerDetails.LABOURCLAIM == null || headerDetails.LABOURCLAIM === "" || headerDetails.LABOURCLAIM == 0.00 || headerDetails.LABOURCLAIM == 0) ? '0.00' : parseFloat(headerDetails.LABOURCLAIM).toFixed(2),
              labourclaimapp: (headerDetails.LABOURCLAIMAPPROVED == null || headerDetails.LABOURCLAIMAPPROVED === "" || headerDetails.LABOURCLAIMAPPROVED == 0.00 || headerDetails.LABOURCLAIMAPPROVED == 0) ? '0.00' : parseFloat(headerDetails.LABOURCLAIMAPPROVED).toFixed(2),
              labourCGSTApproved: (headerDetails.LABOUR_CGST_TAX_APPROVED == null || headerDetails.LABOUR_CGST_TAX_APPROVED === "" || headerDetails.LABOUR_CGST_TAX_APPROVED == 0.00 || headerDetails.LABOUR_CGST_TAX_APPROVED == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_CGST_TAX_APPROVED).toFixed(2),
              labourSGST: (headerDetails.LABOUR_SGST_TAX == null || headerDetails.LABOUR_SGST_TAX === "" || headerDetails.LABOUR_SGST_TAX == 0.00 || headerDetails.LABOUR_SGST_TAX == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_SGST_TAX).toFixed(2),
              labourSGSTApproved: (headerDetails.LABOUR_SGST_TAX_APPROVED == null || headerDetails.LABOUR_SGST_TAX_APPROVED === "" || headerDetails.LABOUR_SGST_TAX_APPROVED == 0.00 || headerDetails.LABOUR_SGST_TAX_APPROVED == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_SGST_TAX_APPROVED).toFixed(2),
              labourIGST: (headerDetails.LABOUR_IGST_TAX == null || headerDetails.LABOUR_IGST_TAX === "" || headerDetails.LABOUR_IGST_TAX == 0.00 || headerDetails.LABOUR_IGST_TAX == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_IGST_TAX).toFixed(2),
              labourIGSTApproved: (headerDetails.LABOUR_IGST_TAX_APPROVED == null || headerDetails.LABOUR_IGST_TAX_APPROVED === "" || headerDetails.LABOUR_IGST_TAX_APPROVED == 0.00 || headerDetails.LABOUR_IGST_TAX_APPROVED == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_IGST_TAX_APPROVED).toFixed(2)
            }));


            // Check if COMPLAINT_DATE exists, then update `billDate` and `billNo`
            if (headerReportDetails.COMPLAINT_DATE) {
              setFormData((prevState) => ({
                ...prevState, // Spread the previous state to retain all existing data
                billDate: headerReportDetails.COMPLAINT_DATE || '', // Set billDate
              }));

              setFormData((prevState) => ({
                ...prevState, // Spread the previous state to retain all existing data
                deliverydate: headerReportDetails.SERVICE_DATE || '', // Set billDate
              }));

              if (headerReportDetails.SERBILLNO && headerReportDetails.SERBILLNO !== '') {
                setFormData((prevState) => ({
                  ...prevState, // Spread previous state to keep all data intact
                  billNo: headerReportDetails.SERBILLNO || '', // Set billNo conditionally
                }));
              }
            }

            if (headerReportDetails.STATUSCODE === "2" || headerReportDetails.STATUSCODE === "02") {
              setFormData((prevState) => ({
                ...prevState,
                status: "CLOSE",
              }));
            }

            if (headerReportDetails.CLAIM_FROM === "02") {
              setFormData((prevState) => ({
                ...prevState,
                claimfrom: "BRANCH",
              }));
            } else if (headerReportDetails.CLAIM_FROM === "01") {
              setFormData((prevState) => ({
                ...prevState,
                claimfrom: "DEALER",
              }));
            } else if (headerReportDetails.CLAIM_FROM === "04") {
              setFormData((prevState) => ({
                ...prevState,
                claimfrom: "CUSTOMER",
              }));
            }




            setloading(false);
          })
          .catch(error => {
            console.error('Error fetching claim details:', error);
            setloading(false);
          });
      }
    } catch (error) {
      setloading(false);
      console.error("Error calling API:", error);
    }
  };
  // const handleChange = (e) => {
  //   const { name, value, type, checked } = e.target;
  //   setFormData({
  //     ...formData,
  //     [name]: type === 'checkbox' ? checked : value,
  //   });
  //   console.log('status',formData.status);
  // };
  const handleChange = (e, newValue = null) => {
    const { name, value, type, checked } = e.target;
    if (name === 'billNo' && value !== '') {
      setError(''); 
    }

    
    if (newValue !== null) {
      setFormData({
        ...formData,
        status1: newValue ? newValue.value : "",
      });
      setError1('')
      console.log('status from Autocomplete', formData.status); 
      return;
    }

  
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });

    console.log('status from other input', formData.status); 
  };
  const handleCostCentreChange = (event, newValue) => {
    
    if (newValue) {
      setError3('');
     
      setFormData({
        ...formData,
        costcentre: newValue.CostCentreCode, 
      });
    }
  };
  const handleOpen = (image) => {
    setSelectedImage(image);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setSelectedImage(null);
  };

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
  };
  const closeButtonStyle = {
    position: 'absolute',
    top: 8,
    right: 8,

  };
  const calculateColumnTotal = (column) => {
    let sum = 0;
    for (let i = 0; i < sparescost.length; i++) {
      const value = sparescost[i][column];
      if (value == null || value === "" || value == 0 || value == 0.00) {
        continue; 
      }
      sum += parseFloat(value); 
    }
    return sum;
  };


  const totalCGST = calculateColumnTotal('CGST_VALUE');
  const totalSGST = calculateColumnTotal('SGST_VALUE');
  const totalIGST = calculateColumnTotal('IGST_VALUE');
  const totalAmount = calculateColumnTotal('TOTAL_AMOUNT');


  const formattedTotalCGST = totalCGST.toFixed(2);
  const formattedTotalSGST = totalSGST.toFixed(2);
  const formattedTotalIGST = totalIGST.toFixed(2);
  const formattedTotalAmount = totalAmount.toFixed(2);

  const calculateColumnTotallabour = (column) => {
    let sum = 0;
    for (let i = 0; i < labourcost.length; i++) {
      const value = labourcost[i][column];
      if (value == null || value === "" || value == 0 || value == 0.00) {
        continue;
      }
      sum += parseFloat(value);
    }
    return sum;
  };

  const totalCGSTT = calculateColumnTotallabour('CGST_VALUE');
  const totalSGSTT = calculateColumnTotallabour('SGST_VALUE');
  const totalIGSTT = calculateColumnTotallabour('IGST_VALUE');
  const totalAmountt = calculateColumnTotallabour('TOTAL_AMOUNT');

  const formattedTotalCGSTT = totalCGSTT.toFixed(2);
  const formattedTotalSGSTT = totalSGSTT.toFixed(2);
  const formattedTotalIGSTT = totalIGSTT.toFixed(2);
  const formattedTotalAmountt = totalAmountt.toFixed(2);

  const handleUnitChange = (event, newValue) => {
    setSelectedstatus(newValue);
  }
  const datechange = (newDate) => {
    
    if (newDate) {
      setError2('');
      const normalizedDate = dayjs(newDate).startOf('day').toDate(); 
      const formattedDate = dayjs(normalizedDate).format('YYYY-MM-DD'); 

   
      setFormData({
        ...formData,
        billDate: formattedDate,  
      });
    }
  };
  const fetchData = async (claimFrom) => {
    if (!claimFrom) return;
    setloading(true);
    try {
      const response = await axios.post(BASE_URL + '/getscbmapprovaldocs', {
        login_id: login_id,
        claim_from: claimFrom.value
      });

      if (response.status === 200) {
        if (response.data.docnos && response.data.docnos.length > 0 && response.data.docnos[0].DOC_NO) {
          setloading(false);
          setServiceClaims(response.data.docnos);
        } else {
          setloading(false);
          setServiceClaims(response.data.docnos)
          Swal.fire({
            icon: "info",
            text: 'No documents found for the selected claim.'
          });

        }
        // setloading(false); 
        //   setServiceClaims(response.data.docnos);  
      } else {
        setloading(false);
        Swal.fire({
          icon: "warning",
          text: 'Unexpected response status. Please try again.'
        });
      }
    } catch (error) {
      setloading(false);
      if (error.response) {
        Swal.fire({
          icon: "warning",
          text: `Error: ${error.response.data.message}`
        });
      } else if (error.request) {
        console.error('No response received');
      } else {
        console.error('Error setting up the request:', error.message);
      }
    }
  };

  useEffect(() => {

    //fetchData();
  }, []);

  const handleOpen1 = () => setOpen1(true);
  useEffect(() => {
    if (!doc_no) return; 
    handleOpenCard(doc_no);
}, [doc_no]);  


  const handleOpenCard = (doc_no) => {
   
     setOpenCard(true);
    setShowTable(false);
    setloading(true);  // Set loading before the API call

    // Make the API call to fetch the claim details
    axios.post(BASE_URL + '/getscclaimdetails', {
      doc_no: doc_no,
      login_id: login_id,
      type:'BM',
    })
      .then(response => {


        const responseData = response.data;
        const headerDetails = responseData.scheader[0] || {};
        const headerReportDetails = responseData.screportheader[0] || {};
        const headeritemdetails = responseData.item[0] || {};
        setShead(responseData.sheader);
        setcostcenter(responseData.costcenter || {});
        setsparescost(responseData.sparescharge || {});
        setlabourcost(responseData.labourcharge || {});
        setproductregistration(responseData.productregistration || {});



        setImages((prevState) => ({
          ...prevState,
          image1: responseData.image1 || '',
          image2: responseData.image2 || '',
          image3: responseData.image3 || '',
          image4: responseData.image4 || '',
        }));


        setFormData((prevState) => ({
          ...prevState,
          costCentre: headerDetails.COSTCENTRE_CODE || '',
          dealerCode: headerDetails.DEALER_CODE || '',
          ascName: headerDetails.ASC_NAME || '',
          docNo: headerDetails.DOC_NO || '',
          serialNo: headerDetails.SERIAL_NO || '',
          itemCode: headerDetails.MAT_CODE || '',
          itemDesc: headeritemdetails.itemdescription || '',
          serviceCallItemNo: headerDetails.SERVICECALL_NO || '',
          serviceType: headerReportDetails.SERVICE_TYPE || '',
          receivedFrom: headerReportDetails.CUSTOMER_NAME || '',
          complaintReason: headerReportDetails.COMPLAINT || '',
          mobile: headerReportDetails.CUSTOMER_PHONE_NUMBER || '',
          address: headerReportDetails.CUSTOMER_ADDRESS || '',
          branch: headerDetails.BRANCH_CODE || '',
          claimamount: (headerDetails.CLAIM_AMOUNT == null || headerDetails.CLAIM_AMOUNT === "" || headerDetails.CLAIM_AMOUNT == 0 || headerDetails.CLAIM_AMOUNT == 0.00) ? '0.00' : parseFloat(headerDetails.CLAIM_AMOUNT).toFixed(2),
          approvedamount: (headerDetails.APPROVED_AMOUNT == null || headerDetails.APPROVED_AMOUNT === "" || headerDetails.APPROVED_AMOUNT == 0 || headerDetails.APPROVED_AMOUNT == 0.00) ? '0.00' : parseFloat(headerDetails.APPROVED_AMOUNT).toFixed(2),
          approvedby: headerDetails.LEVEL1_APPROVED_BY || '',
          labourCGST: (headerDetails.LABOUR_CGST_TAX == null || headerDetails.LABOUR_CGST_TAX === "" || headerDetails.LABOUR_CGST_TAX == 0.00 || headerDetails.LABOUR_CGST_TAX == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_CGST_TAX).toFixed(2),
          sparesclaim: (headerDetails.SPARESCLAIM == null || headerDetails.SPARESCLAIM === "" || headerDetails.SPARESCLAIM == 0.00 || headerDetails.SPARESCLAIM == 0) ? '0.00' : parseFloat(headerDetails.SPARESCLAIM).toFixed(2),
          sparesclaimapp: (headerDetails.SPARESCLAIMAPPROVED == null || headerDetails.SPARESCLAIMAPPROVED === "" || headerDetails.SPARESCLAIMAPPROVED == 0.00 || headerDetails.SPARESCLAIMAPPROVED == 0) ? '0.00' : parseFloat(headerDetails.SPARESCLAIMAPPROVED).toFixed(2),
          labourclaim: (headerDetails.LABOURCLAIM == null || headerDetails.LABOURCLAIM === "" || headerDetails.LABOURCLAIM == 0.00 || headerDetails.LABOURCLAIM == 0) ? '0.00' : parseFloat(headerDetails.LABOURCLAIM).toFixed(2),
          labourclaimapp: (headerDetails.LABOURCLAIMAPPROVED == null || headerDetails.LABOURCLAIMAPPROVED === "" || headerDetails.LABOURCLAIMAPPROVED == 0.00 || headerDetails.LABOURCLAIMAPPROVED == 0) ? '0.00' : parseFloat(headerDetails.LABOURCLAIMAPPROVED).toFixed(2),
          labourCGSTApproved: (headerDetails.LABOUR_CGST_TAX_APPROVED == null || headerDetails.LABOUR_CGST_TAX_APPROVED === "" || headerDetails.LABOUR_CGST_TAX_APPROVED == 0.00 || headerDetails.LABOUR_CGST_TAX_APPROVED == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_CGST_TAX_APPROVED).toFixed(2),
          labourSGST: (headerDetails.LABOUR_SGST_TAX == null || headerDetails.LABOUR_SGST_TAX === "" || headerDetails.LABOUR_SGST_TAX == 0.00 || headerDetails.LABOUR_SGST_TAX == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_SGST_TAX).toFixed(2),
          labourSGSTApproved: (headerDetails.LABOUR_SGST_TAX_APPROVED == null || headerDetails.LABOUR_SGST_TAX_APPROVED === "" || headerDetails.LABOUR_SGST_TAX_APPROVED == 0.00 || headerDetails.LABOUR_SGST_TAX_APPROVED == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_SGST_TAX_APPROVED).toFixed(2),
          labourIGST: (headerDetails.LABOUR_IGST_TAX == null || headerDetails.LABOUR_IGST_TAX === "" || headerDetails.LABOUR_IGST_TAX == 0.00 || headerDetails.LABOUR_IGST_TAX == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_IGST_TAX).toFixed(2),
          labourIGSTApproved: (headerDetails.LABOUR_IGST_TAX_APPROVED == null || headerDetails.LABOUR_IGST_TAX_APPROVED === "" || headerDetails.LABOUR_IGST_TAX_APPROVED == 0.00 || headerDetails.LABOUR_IGST_TAX_APPROVED == 0) ? '0.00' : parseFloat(headerDetails.LABOUR_IGST_TAX_APPROVED).toFixed(2)
        }));


        // Check if COMPLAINT_DATE exists, then update `billDate` and `billNo`
        if (headerReportDetails.COMPLAINT_DATE) {
          setFormData((prevState) => ({
            ...prevState, // Spread the previous state to retain all existing data
            billDate: headerReportDetails.COMPLAINT_DATE || '', // Set billDate
          }));

          setFormData((prevState) => ({
            ...prevState, // Spread the previous state to retain all existing data
            deliverydate: headerReportDetails.SERVICE_DATE || '', // Set billDate
          }));

          if (headerReportDetails.SERBILLNO && headerReportDetails.SERBILLNO !== '') {
            setFormData((prevState) => ({
              ...prevState, // Spread previous state to keep all data intact
              billNo: headerReportDetails.SERBILLNO || '', // Set billNo conditionally
            }));
          }
        }

        if (headerReportDetails.STATUSCODE === "2" || headerReportDetails.STATUSCODE === "02") {
          setFormData((prevState) => ({
            ...prevState,
            status: "CLOSE",
          }));
        }

        if (headerReportDetails.CLAIM_FROM === "02") {
          setFormData((prevState) => ({
            ...prevState,
            claimfrom: "BRANCH",
          }));
        } else if (headerReportDetails.CLAIM_FROM === "01") {
          setFormData((prevState) => ({
            ...prevState,
            claimfrom: "DEALER",
          }));
        } else if (headerReportDetails.CLAIM_FROM === "04") {
          setFormData((prevState) => ({
            ...prevState,
            claimfrom: "CUSTOMER",
          }));
        }



        setOpenCard(true);
        setloading(false);
      })
      .catch(error => {
        console.error('Error fetching claim details:', error);
        setloading(false);
      });
  };


  const handleCloseCard = () => {
    fetchData(selectedclaim);
    setOpenCard(false);
    setShowTable(true);
    setFormData({
      isGSTApplicable: false,
      billNo: '',
      billDate: '',
      costcentre: '',
      dealerCode: '',
      ascName: '',
      docNo: '',
      serialNo: '',
      itemCode: '',
      itemDesc: '',
      serviceCallItemNo: '',
      serviceType: '',
      receivedFrom: '',
      complaintReason: '',
      mobile: '',
      address: '',
      status: '',
      deliverydate: '',
      claimfrom: '',
      branch: '',
      claimamount: '',
      approvedamount: '',
      approvedby: '',
      sparesclaim: '',
      sparesclaimapp: '',
      labourclaim: '',
      labourclaimapp: '',
      labourCGST: '',
      labourCGSTApproved: '',
      labourSGST: '',
      labourSGSTApproved: '',
      labourIGSTApproved: '',
      labourIGST: '',
      status1: '',
    });
    setError2('');
    setError('');
    setError3('');
  };

  const claimfromoptions = [

    { label: 'Dealer', value: 'Dealer' },
    { label: 'Branch', value: 'Branch' },
    { label: 'Customer', value: 'Customer' }
  ];
  const [selectedDate, setSelectedDate] = useState(null);

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  

  //const defaultValue = options[0];
  const hasValidImages = Object.values(images).some((image) => image !== "" && image !== null);


  return (

    <Container>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <br />
    
 

        <div className="service-claim-form">
          <center>
            <h3 style={{ padding: '5px', background: '#5ce0d8', color: 'black' }}>
              Service Claim Report
            </h3>
          </center>
          <hr />



          <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '5px' }}>

           
            <center><h6 style={{ padding: '5px', background: '#01345b', color: 'white'  }} >Service Claim Details</h6></center>
            <br />
            <div className="form-body">

                <Grid item xs={12} sm={4}>  <p style={{ color: 'red', fontweight: 'bolt' }}><h6>{error2}</h6></p> </Grid>              
             
              <Grid container spacing={4} sx={{ marginTop: '-22px' }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="dealerCode"
                    value={formData.dealerCode}
                    onChange={handleChange}
                    name="dealerCode"
                    fullWidth
                    variant="outlined"
                    label="ASC Code"
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="ascName"
                    value={formData.ascName}
                    onChange={handleChange}
                    name="ascName"
                    fullWidth
                    variant="outlined"
                    label="ASC Name" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="docNo"
                    value={formData.docNo}
                    onChange={handleChange}
                    name="docNo"
                    fullWidth
                    variant="outlined"
                    label="Document No" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
              </Grid>


              {/* Serial No, Item Code, Item Description */}
              <Grid container spacing={4} sx={{ marginTop: '-22px' }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="serialNo"
                    value={formData.serialNo}
                    onChange={handleChange}
                    name="serialNo"
                    fullWidth
                    variant="outlined"
                    label="Serial No" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="itemCode"
                    value={formData.itemCode}
                    onChange={handleChange}
                    name="itemCode"
                    fullWidth
                    variant="outlined"
                    label="Item Code" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="itemDesc"
                    value={formData.itemDesc}
                    onChange={handleChange}
                    name="itemDesc"
                    fullWidth
                    variant="outlined"
                    label="Item Description" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
              </Grid>


              <Grid container spacing={4} sx={{ marginTop: '-22px' }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="serviceCallItemNo"
                    value={formData.serviceCallItemNo}
                    onChange={handleChange}
                    name="serviceCallItemNo"
                    fullWidth
                    variant="outlined"
                    label="Service Call Item No" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="serviceType"
                    value={formData.serviceType}
                    onChange={handleChange}
                    name="serviceType"
                    fullWidth
                    variant="outlined"
                    label="Service Type" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="receivedFrom"
                    value={formData.receivedFrom}
                    onChange={handleChange}
                    name="receivedFrom"
                    fullWidth
                    variant="outlined"
                    label="Received From" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={4} sx={{ marginTop: '-22px' }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="complaintReason"
                    value={formData.complaintReason}
                    onChange={handleChange}
                    name="complaintReason"
                    fullWidth
                    variant="outlined"
                    label="Complaint Reason" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="mobile"
                    value={formData.mobile}
                    onChange={handleChange}
                    name="mobile"
                    fullWidth
                    variant="outlined"
                    label="Mobile"
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="address"
                    value={formData.address}
                    onChange={handleChange}
                    name="address"
                    fullWidth
                    variant="outlined"
                    label="Address" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
              </Grid>


            </div>
          </Card>


          <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '5px' }}>
            <center>
              <h6 style={{ padding: '5px',  background: '#01345b', color: 'white'}}>Service Claim Images</h6>
            </center>

            {hasValidImages ? (
              <div>
                {/* Display images in a row using Grid */}
                <Grid container spacing={2}>
                  {Object.values(images).length === 0 ? (
                    <Typography variant="h6" color="error" style={{ width: '100%' }}>
                      Image not found
                    </Typography>
                  ) : (
                    Object.values(images).map((image, index) => (
                      image ? (
                        <Grid item xs={4} key={index}>
                          <img
                            src={`data:image/png;base64,${image}`} // Base64 image encoding
                            alt={`Image ${index + 1}`}
                            style={{
                              width: '180px',
                              height: '180px', // Set a fixed height for all images
                              objectFit: 'cover', // Ensure images are properly scaled
                              cursor: 'pointer',
                              borderRadius: '8px',
                            }}
                            onClick={() => openModal(`data:image/png;base64,${image}`)} // Opens the modal with the clicked image
                          />
                        </Grid>
                      ) : null
                    ))
                  )}
                </Grid>

                {/* Modal to view selected image */}
                <Dialog open={open} onClose={handleClosemodal} maxWidth="md" fullWidth>
                  <DialogTitle>
                    <IconButton
                      edge="end"
                      color="inherit"
                      onClick={handleClosemodal}
                      aria-label="close"
                      sx={{
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                    Service Image
                  </DialogTitle>

                  <DialogContent>
                    {/* Display the selected image */}
                    <img
                      src={selectedImagei} // This will display the base64 encoded image
                      alt="Selected Image"
                      style={{
                        maxWidth: '100%', // Ensure the image doesn't exceed the modal's width
                        maxHeight: '80vh', // Limit image height to 80% of the viewport height
                        width: '100%', // Set a fixed width for all images
                        height: 'auto', // Set height to auto to maintain aspect ratio
                        objectFit: 'contain', // Ensure image scales proportionally and is fully visible
                        borderRadius: '8px', // Optional: Round corners for styling
                      }}
                    />
                  </DialogContent>

                  <DialogActions>
                    <Button
                      onClick={handleClosemodal}
                      variant="outlined"
                      color="error"
                      sx={{ borderRadius: '8px' }}
                    >
                      Close
                    </Button>
                  </DialogActions>
                </Dialog>
              </div>
            ) : (<Grid item xs={12}>
              <img
                src={notFoundImage}  // Show the "not found" image
                alt="Image not found"
                style={{
                  width: '100px',  // You can adjust the size of the "not found" image
                  height: '100px',
                  objectFit: 'contain',  // Ensure the image scales proportionally
                  margin: '0 auto',  // Center the image
                  display: 'block',
                }}
              />
              <Typography variant="h6" color="error" style={{ textAlign: 'center' }}>
                No images found
              </Typography>
            </Grid>)
            }


          </Card>

          <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '5px' }}>
            <center><h6 style={{ padding: '5px',  background: '#01345b', color: 'white'  }} >Details & Cost of Spares Replaced</h6></center>
            {sparescost && sparescost.length > 0 ? (
              <TableContainer component={Paper} style={{ maxHeight: '280px', overflowY: 'auto' }}>
                <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
                  <TableHead
                    style={{
                      position: 'sticky',  // Make the entire header sticky
                      top: 0,              // Stick it to the top
                      backgroundColor: '#fff',  // Add background to prevent overlap issues
                      zIndex: 1,           // Ensure it stays above table body while scrolling
                    }}
                  >
                    <TableRow>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Serial No.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>SCR No.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Spare Code</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Details</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Qty</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Spares Cost Rs.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Grant Total Rs.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>CGST %</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>CGST Value Rs.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>SGST %</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>SGST Value Rs.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>IGST %</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>IGST Value Rs.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Total Value Rs</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {sparescost.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.SERIAL_NO}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.SERVICECALL_NO}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.SPARE_CODE}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.SPARE_NAME}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>{row.QUANTITY}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                          {row.RATE == null || row.RATE === "" || row.RATE == 0 || row.RATE == 0.00 ? '0.00' : parseFloat(row.RATE).toFixed(2)}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                          {row.G_TOTAL == null || row.G_TOTAL === "" || row.G_TOTAL == 0 || row.G_TOTAL == 0.00 ? '0.00' : parseFloat(row.G_TOTAL).toFixed(2)}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                          {row.CGST_PERCENT == null || row.CGST_PERCENT === "" || row.CGST_PERCENT == 0 || row.CGST_PERCENT == 0.00 ? '0.00' : parseFloat(row.CGST_PERCENT).toFixed(2)}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                          {row.CGST_VALUE == null || row.CGST_VALUE === "" || row.CGST_VALUE == 0 || row.CGST_VALUE == 0.00 ? '0.00' : parseFloat(row.CGST_VALUE).toFixed(2)}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                          {row.SGST_PERCENT == null || row.SGST_PERCENT === "" || row.SGST_PERCENT == 0 || row.SGST_PERCENT == 0.00 ? '0.00' : parseFloat(row.SGST_PERCENT).toFixed(2)}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                          {row.SGST_VALUE == null || row.SGST_VALUE === "" || row.SGST_VALUE == 0 || row.SGST_VALUE == 0.00 ? '0.00' : parseFloat(row.SGST_VALUE).toFixed(2)}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                          {row.IGST_PERCENT == null || row.IGST_PERCENT === "" || row.IGST_PERCENT == 0 || row.IGST_PERCENT == 0.00 ? '0.00' : parseFloat(row.IGST_PERCENT).toFixed(2)}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                          {row.IGST_VALUE == null || row.IGST_VALUE === "" || row.IGST_VALUE == 0 || row.IGST_VALUE == 0.00 ? '0.00' : parseFloat(row.IGST_VALUE).toFixed(2)}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black' }}>
                          {row.TOTAL_AMOUNT == null || row.TOTAL_AMOUNT === "" || row.TOTAL_AMOUNT == 0 || row.TOTAL_AMOUNT == 0.00 ? '0.00' : parseFloat(row.TOTAL_AMOUNT).toFixed(2)}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            ) : (
              <Grid item xs={12}>
                <img
                  src={notFoundImage}  // Show the "not found" image
                  alt="Image not found"
                  style={{
                    width: '100px',  // You can adjust the size of the "not found" image
                    height: '100px',
                    objectFit: 'contain',  // Ensure the image scales proportionally
                    margin: '0 auto',  // Center the image
                    display: 'block',
                  }}
                />
                <Typography variant="h6" color="error" style={{ textAlign: 'center' }}>
                  No Spare charges found
                </Typography>
              </Grid>
            )}

            <br />

            <Grid container spacing={4} justifyContent="center">

              {/* CGST Row */}
              <Grid item xs={12} sm={3}>
                <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  <Typography sx={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#495057', // Gray text color for a clean look
                    backgroundColor: '#e9ecef', // Light gray background
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.03)',
                      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                    },
                  }}>
                    Total CGST (Rs.): {formattedTotalCGST}
                  </Typography>
                </Box>
              </Grid>

              {/* SGST Row */}
              <Grid item xs={12} sm={3}>
                <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  <Typography sx={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#495057', // Gray text color
                    backgroundColor: '#e9ecef', // Light gray background
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.03)',
                      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                    },
                  }}>
                    Total SGST (Rs.): {formattedTotalSGST}
                  </Typography>
                </Box>
              </Grid>

              {/* IGST Row */}
              <Grid item xs={12} sm={3}>
                <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  <Typography sx={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#495057', // Gray text color
                    backgroundColor: '#e9ecef', // Light gray background
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.03)',
                      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                    },
                  }}>
                    Total IGST (Rs.): {formattedTotalIGST}
                  </Typography>
                </Box>
              </Grid>

              {/* Total Value Row */}
              <Grid item xs={12} sm={3}>
                <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  <Typography sx={{
                    fontSize: '1rem',
                    fontWeight: '700',
                    color: '#01345b', // White text for contrast
                    backgroundColor: '#ffcf43', // Bold, but muted orange for the Total Value
                    padding: '8px 12px',
                    borderRadius: '10px', // Rounded corners for a smooth, modern effect
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.05)', // Hover scale effect
                      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)', // Stronger shadow
                      backgroundColor: '#ffcf43', // Darker orange on hover
                    },
                  }}>
                    Total Value (Rs.): {formattedTotalAmount}
                  </Typography>
                </Box>
              </Grid>

            </Grid>



          </Card>
          <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '5px' }}>
            <center><h6 style={{ padding: '5px', background: '#01345b', color: 'white' }} >Details & Cost of Labour Charges</h6></center>

            {labourcost && labourcost.length > 0 ? (
              <TableContainer component={Paper} style={{ maxHeight: '280px', overflowY: 'auto' }}>
                <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
                  <TableHead
                    style={{
                      position: 'sticky',  // Make the entire header sticky
                      top: 0,              // Stick it to the top
                      backgroundColor: '#fff',  // Add background to prevent overlap issues
                      zIndex: 1,           // Ensure it stays above table body while scrolling
                    }}
                  >
                    <TableRow>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Serial No.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>SCR No.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Service ID</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Details</TableCell>

                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Labour Charges Rs.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>CGST %</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>CGST Value Rs.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>SGST %</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>SGST Value Rs.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>IGST %</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>IGST Value Rs.</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Total Value Rs</TableCell>


                    </TableRow>
                  </TableHead>
                  <TableBody>

                    {labourcost && labourcost.map((row, index) => (
                      <TableRow key={index}>

                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.SERIAL_NO}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.SERVICECALL_NO}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.LABOURCHARGE_ID}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>{row.LABOURCHARGE_DESCRIPTION}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                          {row.RATE == null || row.RATE === "" || row.RATE == 0 || row.RATE == 0.00 ? '0.00' : parseFloat(row.RATE).toFixed(2)}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                          {row.CGST_PERCENT == null || row.CGST_PERCENT === "" || row.CGST_PERCENT == 0 || row.CGST_PERCENT == 0.00 ? '0.00' : parseFloat(row.CGST_PERCENT).toFixed(2)}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                          {row.CGST_VALUE == null || row.CGST_VALUE === "" || row.CGST_VALUE == 0 || row.CGST_VALUE == 0.00 ? '0.00' : parseFloat(row.CGST_VALUE).toFixed(2)}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                          {row.SGST_PERCENT == null || row.SGST_PERCENT === "" || row.SGST_PERCENT == 0 || row.SGST_PERCENT == 0.00 ? '0.00' : parseFloat(row.SGST_PERCENT).toFixed(2)}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                          {row.SGST_VALUE == null || row.SGST_VALUE === "" || row.SGST_VALUE == 0 || row.SGST_VALUE == 0.00 ? '0.00' : parseFloat(row.SGST_VALUE).toFixed(2)}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                          {row.IGST_PERCENT == null || row.IGST_PERCENT === "" || row.IGST_PERCENT == 0 || row.IGST_PERCENT == 0.00 ? '0.00' : parseFloat(row.IGST_PERCENT).toFixed(2)}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                          {row.IGST_VALUE == null || row.IGST_VALUE === "" || row.IGST_VALUE == 0 || row.IGST_VALUE == 0.00 ? '0.00' : parseFloat(row.IGST_VALUE).toFixed(2)}</TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', transition: 'transform 0.2s ease-in-out' }}>
                          {row.TOTAL_AMOUNT == null || row.TOTAL_AMOUNT === "" || row.TOTAL_AMOUNT == 0 || row.TOTAL_AMOUNT == 0.00 ? '0.00' : parseFloat(row.TOTAL_AMOUNT).toFixed(2)}</TableCell>


                      </TableRow>
                    ))}

                  </TableBody>
                </Table>
              </TableContainer>) : (
              <Grid item xs={12}>
                <img
                  src={notFoundImage}  // Show the "not found" image
                  alt="Image not found"
                  style={{
                    width: '100px',  // You can adjust the size of the "not found" image
                    height: '100px',
                    objectFit: 'contain',  // Ensure the image scales proportionally
                    margin: '0 auto',  // Center the image
                    display: 'block',
                  }}
                />
                <Typography variant="h6" color="error" style={{ textAlign: 'center' }}>
                  No Labour charges found
                </Typography>
              </Grid>
            )}
            <br />

            <Grid container spacing={4} justifyContent="center">

              {/* CGST Row */}
              <Grid item xs={12} sm={3}>
                <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  <Typography sx={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#495057', // Gray text color for a clean look
                    backgroundColor: '#e9ecef', // Light gray background
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.03)',
                      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                    },
                  }}>
                    Total CGST (Rs.): {formattedTotalCGSTT}
                  </Typography>
                </Box>
              </Grid>

              {/* SGST Row */}
              <Grid item xs={12} sm={3}>
                <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  <Typography sx={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#495057', // Gray text color
                    backgroundColor: '#e9ecef', // Light gray background
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.03)',
                      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                    },
                  }}>
                    Total SGST (Rs.): {formattedTotalSGSTT}
                  </Typography>
                </Box>
              </Grid>

              {/* IGST Row */}
              <Grid item xs={12} sm={3}>
                <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  <Typography sx={{
                    fontSize: '1rem',
                    fontWeight: '600',
                    color: '#495057', // Gray text color
                    backgroundColor: '#e9ecef', // Light gray background
                    padding: '8px 12px',
                    borderRadius: '8px',
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.03)',
                      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                    },
                  }}>
                    Total IGST (Rs.): {formattedTotalIGSTT}
                  </Typography>
                </Box>
              </Grid>

              {/* Total Value Row */}
              <Grid item xs={12} sm={3}>
                <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                  <Typography sx={{
                    fontSize: '1rem',
                    fontWeight: '700',//#fff,#ffcf43,#ffcf43
                    color: '#01345b', // White text for contrast
                    backgroundColor: '#ffcf43', // Bold, but muted orange for the Total Value
                    padding: '8px 12px',
                    borderRadius: '10px', // Rounded corners for a smooth, modern effect
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                    transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
                    '&:hover': {
                      transform: 'scale(1.05)', // Hover scale effect
                      boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)', // Stronger shadow
                      backgroundColor: '#ffcf43', // Darker orange on hover
                    },
                  }}>
                    Total Value (Rs.): {formattedTotalAmountt}
                  </Typography>
                </Box>
              </Grid>

            </Grid>
          </Card>
          <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '5px' }}>
            <center><h6 style={{ padding: '5px', background: '#01345b', color: 'white'  }} >Spares & labour Claim Charges</h6></center>
            <br />
            <div className="form-body">

              <Grid container spacing={4} sx={{ marginTop: '-22px', justifyContent: 'center', alignItems: 'center' }}>

                <Grid item xs={12} sm={4}>
                  <TextField
                    id="sparesclaim"
                    value={formData.sparesclaim}
                    onChange={handleChange}
                    name="sparesclaim"
                    fullWidth
                    variant="outlined"
                    label="Spares Claim"
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="sparesclaimapp"
                    value={formData.sparesclaimapp}
                    onChange={handleChange}
                    name="sparesclaimapp"
                    fullWidth
                    variant="outlined"
                    label="Spares Claim Approved"
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>

              </Grid>
              <Grid container spacing={4} sx={{ marginTop: '-22px', justifyContent: 'center', alignItems: 'center' }}>

                {/* Labour Claim */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="labourClaim"
                    value={formData.labourclaim}
                    onChange={handleChange}
                    name="labourClaim"
                    fullWidth
                    variant="outlined"
                    label="Labour Claim" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>

                {/* Labour Claim Approved */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="labourClaimApproved"
                    value={formData.labourclaimapp}
                    onChange={handleChange}
                    name="labourClaimApproved"
                    fullWidth
                    variant="outlined"
                    label="Labour Claim Approved" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={4} sx={{ marginTop: '-22px', justifyContent: 'center', alignItems: 'center' }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="labourCGST"
                    value={formData.labourCGST}
                    onChange={handleChange}
                    name="labourCGST"
                    fullWidth
                    variant="outlined"
                    label="Labour CGST" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>

                {/* Labour CGST Approved */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="labourCGSTApproved"
                    value={formData.labourCGSTApproved}
                    onChange={handleChange}
                    name="labourCGSTApproved"
                    fullWidth
                    variant="outlined"
                    label="Labour CGST Approved" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={4} sx={{ marginTop: '-22px', justifyContent: 'center', alignItems: 'center' }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="labourSGST"
                    value={formData.labourSGST}
                    onChange={handleChange}
                    name="labourSGST"
                    fullWidth
                    variant="outlined"
                    label="Labour SGST" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>

                {/* Labour SGST Approved */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="labourSGSTApproved"
                    value={formData.labourSGSTApproved}
                    onChange={handleChange}
                    name="labourSGSTApproved"
                    fullWidth
                    variant="outlined"
                    label="Labour SGST Approved" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>
              </Grid>

              <Grid container spacing={4} sx={{ marginTop: '-22px', justifyContent: 'center', alignItems: 'center' }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="labourIGST"
                    value={formData.labourIGST}
                    onChange={handleChange}
                    name="labourIGST"
                    fullWidth
                    variant="outlined"
                    label="Labour IGST" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>

                {/* Labour IGST Approved */}
                <Grid item xs={12} sm={4}>
                  <TextField
                    id="labourIGSTApproved"
                    value={formData.labourIGSTApproved}
                    onChange={handleChange}
                    name="labourIGSTApproved"
                    fullWidth
                    variant="outlined"
                    label="Labour IGST Approved" // Label inside the field
                    InputProps={{ readOnly: true }}
                    size="small"
                  />
                </Grid>

              </Grid>






            </div>
          </Card>
          <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '5px' }}>
            <center><h6 style={{ padding: '5px',  background: '#01345b', color: 'white'}} >Product Registration Information</h6></center>
            {productregistration && productregistration.length > 0 ? (
              <TableContainer component={Paper}>
                <Table style={{ borderCollapse: 'separate', borderSpacing: '4px', width: '100%', textAlign: 'center', fontSize: '15px' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Customer Name</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Customer Mobile Number</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Customer Invoice Date</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Customer Invoice Number</TableCell>
                      <TableCell style={{ padding: '5px', background: '#61d1e5', color: 'black', fontWeight: 'bold', textAlign: 'center' }}>Registration Date</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {productregistration.map((row, index) => (
                      <TableRow key={index}>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textAlign: 'center' }}>
                          {row.CUSTOMER_NAME}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textAlign: 'center' }}>
                          {row.MOBILE_NO}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textAlign: 'center' }}>
                          {row.INVOICE_DATE}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textAlign: 'center' }}>
                          {row.INVOICENO}
                        </TableCell>
                        <TableCell style={{ padding: '10px', background: '#e3fafe', color: 'black', textAlign: 'center' }}>
                          {row.RegistrationDate}
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>

            ) : (
              <Grid item xs={12}>
                <img
                  src={notFoundImage}  // Show the "not found" image
                  alt="Image not found"
                  style={{
                    width: '100px',  // You can adjust the size of the "not found" image
                    height: '100px',
                    objectFit: 'contain',  // Ensure the image scales proportionally
                    margin: '0 auto',  // Center the image
                    display: 'block',
                  }}
                />
                <Typography variant="h6" color="error" style={{ textAlign: 'center' }}>
                  Product Registration not done yet
                </Typography>
              </Grid>
            )}


          </Card>
          <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '5px' }}>
            <center><h6 style={{ padding: '5px',background: '#01345b', color: 'white' }} >Status Of Service Claim Document</h6></center>

            <div className="form-body">

              {/* <Grid container spacing={4} sx={{ marginTop: '-22px'}}>
         
  <Grid item xs={12} sm={3}>
  <TextField
      id="status"
      value={formData.status}
      onChange={handleChange}
      name="status"
      fullWidth
      variant="outlined"
      label="Status"
      InputProps={{ readOnly: true }}
      size="small"
    />
  </Grid>
  <Grid item xs={12} sm={3}>

<TextField
  id="deliverydate"
  value={formData.deliverydate ? dayjs(formData.deliverydate).format('DD-MM-YYYY') : ''}  // Format date to 'dd-MM-yyyy'
  onChange={handleChange}
  name="deliverydate"
  fullWidth
  variant="outlined"
  label="Delivery Date"
  InputProps={{ readOnly: true }}
  size="small"
/>


  </Grid>
  <Grid item xs={12} sm={3}>
  <TextField
      id="claimfrom"
      value={formData.claimfrom}
      onChange={handleChange}
      name="claimfrom"
      fullWidth
      variant="outlined"
      label="Claim From"
      InputProps={{ readOnly: true }}
      size="small"
    />
    </Grid>
    <Grid item xs={12} sm={3}>
    <TextField
      id="Branch"
      value={formData.branch}
      onChange={handleChange}
      name="Branch"
      fullWidth
      variant="outlined"
      label="Branch"
      InputProps={{ readOnly: true }}
      size="small"
    />
    </Grid>


</Grid> */}


              <Grid container spacing={3} sx={{ marginTop: '-22px' }}>



                {/* SGST Row */}
                <Grid item xs={12} sm={4}>
                  <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <Typography sx={{
                      fontSize: '1rem',
                     // fontWeight: '600',
                      color: '#262a2d', // Gray text color for a clean look
                      backgroundColor: '#e9ecef', // Light gray background
                      padding: '8px 12px',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                      },
                    }}>
                      Status: <span style={{ fontWeight: '600' }}> {formData.status}</span>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <Typography sx={{
                      fontSize: '1rem',
                     // fontWeight: '600',
                      color: '#262a2d', // Gray text color for a clean look
                      backgroundColor: '#e9ecef', // Light gray background
                      padding: '8px 12px',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                      },
                    }}>
                      Bill No: <span style={{ fontWeight: '600' }}>{formData.billNo}</span>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <Typography sx={{
                      fontSize: '1rem',
                     //  // fontWeight: '600',
                      color: '#262a2d', // Gray text color for a clean look
                      backgroundColor: '#e9ecef', // Light gray background
                      padding: '8px 12px',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                      },
                    }}>
                      Bill Date: <span style={{ fontWeight: '600' }}>
  {formData.billDate ? dayjs(formData.deliverydate).format('DD-MM-YYYY') : ''}
</span>
                    </Typography>
                  </Box>
                </Grid>

                {/* IGST Row */}
               
              </Grid>

<hr/>
              <Grid container spacing={3} sx={{ marginTop: '-22px' }}><Grid item xs={12} sm={4}>
                  <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <Typography sx={{
                      fontSize: '1rem',
                       // fontWeight: '600',
                      color: '#262a2d', // Gray text color for a clean look
                      backgroundColor: '#e9ecef', // Light gray background
                      padding: '8px 12px',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                      },
                    }}>
                      Delivery Date: <span style={{ fontWeight: '600' }}>{formData.deliverydate ? dayjs(formData.deliverydate).format('DD-MM-YYYY') : ''}</span>
                    </Typography>
                  </Box>
                </Grid>

                {/* Total Value Row */}
                <Grid item xs={12} sm={4}>
                  <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <Typography sx={{
                      fontSize: '1rem',
                       // fontWeight: '600',
                      color: '#262a2d', // Gray text color for a clean look
                      backgroundColor: '#e9ecef', // Light gray background
                      padding: '8px 12px',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                      },
                    }}>
                      Claim From : <span style={{ fontWeight: '600' }}>{formData.claimfrom}</span>
                    </Typography>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={4}>
                  <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <Typography sx={{
                      fontSize: '1rem',
                       // fontWeight: '600',
                      color: '#262a2d', // Gray text color for a clean look
                      backgroundColor: '#e9ecef', // Light gray background
                      padding: '8px 12px',
                      borderRadius: '8px',
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.05)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.03)',
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.1)', // Hover shadow
                      },
                    }}>
                      Branch : <span style={{ fontWeight: '600' }}>{formData.branch}</span>
                    </Typography>
                  </Box>
                </Grid></Grid>



            </div>
          </Card>
          <Card style={{ boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)', borderRadius: '5px' }}>


            <div className="form-body">


              {/* <Grid container spacing={4} sx={{ marginTop: '-22px' }}>

<Grid item xs={12} sm={3}>
  <TextField
      id="claimamount"
      value={formData.claimamount}
      onChange={handleChange}
      name="claimamount"
      fullWidth
      variant="outlined"
      label="Claim Amount"
      InputProps={{ readOnly: true }}
      size="small"
      sx={{
        '& .MuiInputLabel-root': {
          fontWeight: 'bold', // Set the label to bold
        },
      }}
    />
    </Grid>
    <Grid item xs={12} sm={3}>
  <TextField
      id="approvedamount"
      value={formData.approvedamount}
      onChange={handleChange}
      name="approvedamount"
      fullWidth
      variant="outlined"
      label="Approved Amount"
      InputProps={{ readOnly: true }}
      size="small"
      sx={{
        '& .MuiInputLabel-root': {
          fontWeight: 'bold', // Set the label to bold
        },
      }}
    />
  </Grid>
  <Grid item xs={12} sm={3}>
  <TextField
      id="approvedby"
      value={formData.approvedby}
      onChange={handleChange}
      name="approvedby"
      fullWidth
      variant="outlined"
      label="Approved By"
      InputProps={{ readOnly: true }}
      size="small"
      sx={{
        '& .MuiInputLabel-root': {
          fontWeight: 'bold', // Set the label to bold
        },
      }}
    />
  </Grid>
  

</Grid> */}
              <Grid container spacing={4} sx={{ marginTop: '-22px' }}>



                {/* SGST Row */}
                <Grid item xs={12} sm={6}>
                  <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <Typography sx={{
                      fontSize: '1rem',
                     // fontWeight: '700',//#fff,#ffcf43,#ffcf43
                      color: '#01345b', // White text for contrast
                      backgroundColor: '#ffcf43', // Bold, but muted orange for the Total Value
                      padding: '8px 12px',
                      borderRadius: '10px', // Rounded corners for a smooth, modern effect
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.05)', // Hover scale effect
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)', // Stronger shadow
                        backgroundColor: '#ffcf43', // Darker orange on hover
                      },
                    }}>
                      Claim Amount (Rs.): <span style={{ fontWeight: '700' }}>{formData.claimamount}</span>
                    </Typography>
                  </Box>
                </Grid>

                {/* IGST Row */}
                <Grid item xs={12} sm={6}>
                  <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <Typography sx={{
                      fontSize: '1rem',
                     // fontWeight: '700',//#fff,#ffcf43,#ffcf43
                      color: '#01345b', // White text for contrast
                      backgroundColor: '#ffcf43', // Bold, but muted orange for the Total Value
                      padding: '8px 12px',
                      borderRadius: '10px', // Rounded corners for a smooth, modern effect
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.05)', // Hover scale effect
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)', // Stronger shadow
                        backgroundColor: '#ffcf43', // Darker orange on hover
                      },
                    }}>
                      Approved Amount (Rs.): <span style={{ fontWeight: '700' }}>{formData.approvedamount}</span>
                    </Typography>
                  </Box>
                </Grid>

                {/* Total Value Row */}
                {/* <Grid item xs={12} sm={4}>
                  <Box sx={{ textAlign: 'center', fontWeight: 'bold' }}>
                    <Typography sx={{
                      fontSize: '1rem',
                      //fontWeight: '700',//#fff,#ffcf43,#ffcf43
                      color: '#01345b', // White text for contrast
                      backgroundColor: '#ffcf43', // Bold, but muted orange for the Total Value
                      padding: '8px 12px',
                      borderRadius: '10px', // Rounded corners for a smooth, modern effect
                      boxShadow: '0 4px 8px rgba(0, 0, 0, 0.15)',
                      transition: 'transform 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
                      '&:hover': {
                        transform: 'scale(1.05)', // Hover scale effect
                        boxShadow: '0 6px 16px rgba(0, 0, 0, 0.15)', // Stronger shadow
                        backgroundColor: '#ffcf43', // Darker orange on hover
                      },
                    }}>
                      Approved By : <span style={{ fontWeight: '700' }}> {formData.approvedby}</span>
                    </Typography>
                  </Box>
                </Grid> */}
              </Grid>
              <br />
              <br />
              {/* <Grid container spacing={2} sx={{ marginTop: '-22px' }}>
                <Grid item xs={12} sm={6}>
                  <FormControl fullWidth variant="outlined" size="small">
                    <Autocomplete
                      value={statusoptions.find(option => option.value === formData.status1) || null}
                      onChange={handleChange}
                      options={statusoptions}
                      getOptionLabel={(option) => option.Label}
                      renderInput={(params) => <TextField {...params} label="Status of Approval" inputRef={status1InputRef}
                        error={!!error1}
                        helperText={error1} />}
                      isOptionEqualToValue={(option, value) => option.value === value.value}

                      disableClearable
                      defaultValue="Small"
                      size="small"
                      sx={{
                        '& .MuiInputLabel-root': {
                          fontWeight: 'bold', // Bold label
                          color: '#1976d2',  // Custom label color (blue in this case)
                        },
                        '& .MuiOutlinedInput-root': {
                          '& fieldset': {
                            borderColor: '#1976d2', // Custom border color (blue in this case)
                          },
                          '&:hover fieldset': {
                            borderColor: '#004ba0', // Darker blue border when hovered
                          },
                          '&.Mui-focused fieldset': {
                            borderColor: '#004ba0', // Focused border color (darker blue)
                          },
                        },
                      }}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    id="reason"
                    value={formData.reason}
                    onChange={handleChange}
                    name="reason"
                    fullWidth
                    variant="outlined"
                    label="Reason"
                    //InputProps={{ readOnly: true }}
                    size="small"
                    sx={{
                      '& .MuiInputLabel-root': {
                        fontWeight: 'bold', // Bold label
                        color: '#1976d2',  // Custom label color (blue in this case)
                      },
                      '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                          borderColor: '#1976d2', // Custom border color (blue in this case)
                        },
                        '&:hover fieldset': {
                          borderColor: '#004ba0', // Darker blue border when hovered
                        },
                        '&.Mui-focused fieldset': {
                          borderColor: '#004ba0', // Focused border color (darker blue)
                        },
                      },
                    }}
                  />
                </Grid>


              </Grid>

              <Grid container justifyContent="center" alignItems="center" sx={{ marginTop: '20px' }}>
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSave}
                    sx={{ width: '300px' }}
                    style={{ fontweight: 'bold' }}
                  >
                    <h6>Save</h6>
                  </Button>
                </Grid>
              </Grid>
              <Box sx={{ marginTop: '20px' }}>
                <Typography
                  variant="body2"
                  color="textSecondary"
                  sx={{ fontWeight: 'bold', color: 'red' }} // Make the entire text bold
                >
                  <strong>Note:</strong><br />
                  1. If GST is applicable, GST should be included in the Invoice.<br />
                  2. If non-filing of Returns / GST is not paid else GST is not reflected in our GSTR-2B return, the GST amount will be debited to the respective service provider and will be collected.
                </Typography>
              </Box> */}


            </div>
          </Card>
        </div>






    </Container>
  );
};

export default Service_Claim_BM_Approval;
